var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.675 30.5H2.00834C1.56631 30.5 1.14239 30.3244 0.82983 30.0118C0.517269 29.6993 0.341675 29.2754 0.341675 28.8333V2.16667C0.341675 1.72464 0.517269 1.30072 0.82983 0.988155C1.14239 0.675595 1.56631 0.5 2.00834 0.5H13.675C13.675 1.38405 14.0262 2.2319 14.6513 2.85702C15.2764 3.48214 16.1243 3.83333 17.0083 3.83333C17.8924 3.83333 18.7402 3.48214 19.3654 2.85702C19.9905 2.2319 20.3417 1.38405 20.3417 0.5H32.0083C32.4504 0.5 32.8743 0.675595 33.1869 0.988155C33.4994 1.30072 33.675 1.72464 33.675 2.16667V28.8333C33.675 29.2754 33.4994 29.6993 33.1869 30.0118C32.8743 30.3244 32.4504 30.5 32.0083 30.5H20.3417C20.3417 29.6159 19.9905 28.7681 19.3654 28.143C18.7402 27.5179 17.8924 27.1667 17.0083 27.1667C16.1243 27.1667 15.2764 27.5179 14.6513 28.143C14.0262 28.7681 13.675 29.6159 13.675 30.5ZM7.00834 8.83333V22.1667H10.3417V8.83333H7.00834ZM23.675 8.83333V22.1667H27.0083V8.83333H23.675Z",
    fill: "#558223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVoucherIcon);
export default __webpack_public_path__ + "static/media/totalVoucherIcon.ac9ce8c1d3098029e4e3e847a522e963.svg";
export { ForwardRef as ReactComponent };